module.exports = __webpack_public_path__ + "static/media/photo58.33e4e4bf.jpg";